module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-loading",
    style: (_vm.loadingStyle),
    domProps: {
      "innerHTML": _vm._s(_vm.svg)
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09ed86b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading.vue
// module id = 15
// module chunks = 0